<div class="content-scroll-screen-multi-component">
  <jni-bcledger-filter
    #filter
    [bcList]="bcList"
    (bcLedgerFormEvent)="getBcLedgerFormData($event)"
    [bcSelectedId]="bcLedgerFilter.brandingConsultantID || ''"
    [selectedDateRange]="bcLedgerFilter.dateRange || ''"></jni-bcledger-filter>
  <jni-total-bclegder
    *ngIf="totalBcLegderLists?.length"
    [totalBcLegderLists]="totalBcLegderLists"
    [bcLedgerFilter]="bcLedgerFilter"></jni-total-bclegder>
  <jni-year-to-date-summary
    *ngIf="ytdSummaryList?.length"
    [yearToDateSummaryLists]="ytdSummaryList"
    [bcLedgerFilter]="bcLedgerFilter"></jni-year-to-date-summary>
  <jni-commision-program-tier
    *ngIf="commissionProgramTierList?.length"
    [commissionProgramTierLists]="
      commissionProgramTierList
    "></jni-commision-program-tier>
</div>
